import { getProxiedServiceUrl } from 'wmic-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

const SN_UTIL_FEATURE_FLAG_QNB = 'utilFeatureFlagQNB';

/**
 * Unauthenticated QNB feature-flag service for use by Quote-and-Buy (CE).
 * Calls the dedicated edge endpoint and never sends Authorization headers.
 */
export default class UtilFeatureFlagQnbServiceUnauth {
    static getAllFeatureFlags() {
        return JsonRPCService.send(getProxiedServiceUrl(SN_UTIL_FEATURE_FLAG_QNB), 'getAllFeatureFlags', [], {});
    }

    static getFeatureFlag(flagName) {
        return JsonRPCService.send(getProxiedServiceUrl(SN_UTIL_FEATURE_FLAG_QNB), 'getFeatureFlag', [flagName], {});
    }

    static isFeatureFlagActive(flagName) {
        return JsonRPCService.send(getProxiedServiceUrl(SN_UTIL_FEATURE_FLAG_QNB), 'isFeatureFlagActive', [flagName], {});
    }
}
